<template>
  <common-panel
    class="new-training-center"
    title="店铺数据"
    :ifShowMore="true"
    :isShowPaddingTop="false"
    moreTarget="_blank"
    moreLink="//zhs.haiziwang.com/timely/overview"
  >
    <a-tabs :activeKey='activeKey' @change="change">
      <div slot="tabBarExtraContent" class="right-action" v-if="activeKey == 0">
        <span class="update-time">更新时间：{{updateTime}}</span>
        <img src="@/assets/images/update.png" alt=""  @click="updateRealData" :class="showAnimation ? 'Rotation' : ''">
      </div>
      <a-tab-pane tab="实时" key='0'>
        <RealData :updateTime.sync="updateTime" ref="real_data"/>
      </a-tab-pane>
      <a-tab-pane tab="交易" key="1">
        <TradeData :showYyData="false"/>
      </a-tab-pane>
      <a-tab-pane tab="商品" key="2">
        <Production />
      </a-tab-pane>
      <!--会员12月期不上-->
      <!--<a-tab-pane tab="会员" key="3">
        <Member />
      </a-tab-pane>-->
    </a-tabs>
  </common-panel>
</template>

<script>
import { Tabs } from 'ant-design-vue'

import CommonPanel from "@/components/common-panel/index"
import RealData from './components/realTimeData'
import TradeData from './components/tradeData'
import Production from './components/production'
// import Member from './components/member'

const { TabPane } = Tabs
export default {
  components: {
    CommonPanel,
    RealData,
    TradeData,
    Production,
    // Member,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane
  },
  data () {
    return {
      activeKey: '0',
      updateTime:'',
      showAnimation: false
    }
  },

  methods: {
    // 刷新实时数据
    updateRealData () {
      this.$refs.real_data.queryRealTimeDate()
      this.$refs.real_data.queryTopData()
      this.showAnimation = true
      setTimeout(() => {
        this.showAnimation = false
      },1000)
    },
    change (key) {
      this.activeKey = key
    }
  }
}
</script>

<style lang="scss" scoped>
.right-action {
  display: flex;
  align-items: center;
  .update-time {
    font-family: MicrosoftYaHei;
    font-size: 12px;
    color: #666666;
    letter-spacing: 0;
    margin-right: 5px;
    flex-shrink: 0;
  }
  img {
    flex-shrink: 0;
    width: 14px;
    height: 14px;
    cursor: pointer;
  }
  .Rotation{
    animation: rotation 1s ease-in-out 1;
    -moz-animation: rotation 1s ease-in-out 1;
    -webkit-animation: rotation 1s ease-in-out 1;
    -o-animation: rotation 1s ease-in-out 1;
  }
}


@keyframes rotation{
  from {-webkit-transform: rotate(0deg);}
  to {-webkit-transform: rotate(180deg);}
}
</style>
